import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { ProductAttribute } from '@barboxx/models';

const COLUMNS: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 200, flex: 1 },
];

interface Props {
    data: ProductAttribute[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function AttributeTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Product Attributes">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
